import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import './index.css';

// Create the root
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ClerkProvider 
        publishableKey="pk_test_Y2FsbS1yYWNlci04OC5jbGVyay5hY2NvdW50cy5kZXYk" 
        afterSignOutUrl="/dashboard"
      >
        <App />
      </ClerkProvider>
    </BrowserRouter>
  </React.StrictMode>
);
